// eslint-disable-next-line @tencent/tdoc-standalone/no-use-location-host
var supportHostnames = [location.hostname];

// 该方法本意是区分腾讯文档链接，以便于不用走pwa，走了也缓存不了
// TODO: 方法可能不稳定
export var isTencentDocHost = function isTencentDocHost(urlStr) {
  var url = new URL(urlStr);
  return supportHostnames.includes(url.hostname);
};
export var isAttachment = function isAttachment(res) {
  return !!res.result.fileMeta.hostFileId;
};
export var isSupportClientDB = function isSupportClientDB() {
  var tdocFlag = /_tdocFlag\/(\d+)/.exec(navigator.userAgent);
  if (tdocFlag !== null && tdocFlag !== void 0 && tdocFlag[1]) {
    var num = parseInt(tdocFlag[1], 10);
    return (num & 0x2) > 0;
  }
  return false;
};
export function resolveUrl(url) {
  if (url.startsWith('http')) return url;
  var urlObj = new URL(url, location.origin);
  return urlObj.toString();
}

// 判断传入的fileId是否是secretId, TODO: 这个方法目前不算稳定
export var isSecretId = function isSecretId(id, hasObjKey) {
  if (hasObjKey) return false;
  if (id.startsWith('D')) return true;
  return false;
};
//# sourceMappingURL=utils.js.map